module.exports = __webpack_public_path__ + "img/operation_drag1.ef9eb588.svg";